
import MainLayout from '../../components/layout/MainLayout';

export default function EmptyPage() {
  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center h-[calc(100vh-200px)]">
        <div className="w-64 h-64 mb-8 flex items-center justify-center">
          <img
            src="https://public.readdy.ai/ai/img_res/2f3e9e4a33314e421dc9b4e6527f2d6c.jpg"
            alt="Empty State"
            className="w-full h-full object-contain"
          />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">功能开发中</h3>
        <p className="text-sm text-gray-500">该功能正在紧张开发中，敬请期待</p>
      </div>
    </MainLayout>
  );
}
